import z from 'zod'

const callbackStateSchema = z.union([
  z.string(),
  z.object({
    /**
     * If set to true, we'll attempt to redirect to the electron app using a deep link.
     */
    desktop: z.optional(z.boolean()),
    redirectTo: z.string(),
  }),
])

export type CallbackState = z.infer<typeof callbackStateSchema>

export default function parseState(state: string): CallbackState {
  try {
    return callbackStateSchema.parse(JSON.parse(state))
  } catch {
    return state
  }
}
